const sanitizeSegment = (value: string) =>
  // Fallback to an empty string so unexpected falsy values do not break `.trim()`.
  encodeURIComponent(
    // Remove surrounding whitespace before encoding the segment.
    (value || '').trim()
  );

const toSafeUrl = (value: string | null | undefined): string | null => {
  // Reject missing values early.
  if (!value) {
    return null;
  }

  // Normalize the input by removing leading and trailing whitespace.
  const trimmedValue = value.trim();

  // Reject values that become empty after trimming.
  if (!trimmedValue) {
    return null;
  }

  try {
    // Parse every value as a URL, using the current origin as a base for relative paths.
    const parsed = new URL(trimmedValue, window.location.origin);

    // Only allow standard web protocols and reject dangerous schemes like `javascript:`.
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return null;
    }

    // For relative or root-relative values, enforce same-origin.
    if (!/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(trimmedValue)) {
      if (parsed.origin !== window.location.origin) {
        return null;
      }

      // Keep relative URLs relative after validation.
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }

    // Absolute http(s) URLs are allowed and normalized.
    return parsed.toString();
  } catch (e) {
    // If parsing fails, treat the value as unsafe.
    return null;
  }
};

export { sanitizeSegment, toSafeUrl };
